import React from "react"

import type { ProductBannerProps } from "./ProductBanner/ProductBanner"
import { ProductBanner } from "./ProductBanner/ProductBanner"

type SidebarProps = ProductBannerProps

export const Sidebar = ({ product }: SidebarProps) => (
  <div className="hidden w-full flex-1 px-6 xl:block">
    <div className="sticky top-8 w-full">
      <ProductBanner product={product} className="rounded-lg" />
    </div>
  </div>
)
